import { ca } from "date-fns/locale";
import { skipActivityInManifest } from "./assignment/updateManifest";

const grade0CalibrationManifest = [
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7b35c79b-bda4-4414-aec4-8d7acb4a1028",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ec71a453-977e-4a6a-a3f0-a5c20db2e0b2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "119302ac-d0f2-4852-8846-6d6d690aeca3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f583ec9d-f2d7-4b11-aa20-90de6984c070",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c73826d4-3762-4959-b27e-3df4199d4553",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "da0162ca-146b-4417-8b62-025ae9ea04bf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "119302ac-d0f2-4852-8846-6d6d690aeca3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "94987144-4882-44fa-880b-16d2808e8637",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "70363f24-310a-47fb-adca-f96dd1bd90aa",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8894fe90-0224-47d9-8c9f-439b0f04aeac",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2829ff5d-afa0-4f5d-bad7-068bcde36a5c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2420ec83-e5b9-4b4d-8f4e-02a54364aad0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "07b05f4a-8c4b-44d4-add8-921cdfba6798",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bb97e54b-8dd2-4631-bdae-685c3976a3f8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2829ff5d-afa0-4f5d-bad7-068bcde36a5c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1a299e66-f4a7-43f0-9745-15268a523f35",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fb378a58-d1b9-40d5-834b-aa9624cbc869",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d31ea9dc-ac43-4020-9a01-59438a06c1a4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5c458432-7e70-42c9-8537-ebec8bcb95fa",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "30bde3ac-60f1-4301-814a-110e558f6257",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e3ad45c7-8662-4903-bf05-520aabf1ac9f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "15fd95f3-aa34-4a93-a02f-22ffec686d4c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5c458432-7e70-42c9-8537-ebec8bcb95fa",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d167914d-2994-4e7b-9e6e-fe449eba52e7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3f784955-91e8-4bc3-9f20-b6d764ef5fab",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1e7e6206-521d-4132-9d32-da23aa037e6f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7a645c6a-9ace-4341-a7aa-cf31c37ab93e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a9c9098d-8d50-4e13-8c46-b25cb291558f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "850f18d6-d330-4c5c-b65b-9010e139c771",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6fbd6f60-25b4-49a5-beaf-581b1f279f32",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7a645c6a-9ace-4341-a7aa-cf31c37ab93e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6145fc44-6158-4c25-adfb-e1e249129da3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "40164902-de94-4faa-9008-ff0213106ed3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "15cc2162-a78c-418b-91af-aa534f27c46a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "81059c71-2ab0-49e6-8da7-b4a15ac709c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "779768b5-0d94-4826-bded-0d82ec84725e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e0c7494b-449a-4e43-89f3-a569ebb1d948",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "802b5415-8e25-43c2-b366-b5a8e0a92e36",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "81059c71-2ab0-49e6-8da7-b4a15ac709c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ff1d2171-828f-4bc9-8b20-72533cab37d5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "609ad2e6-0053-4864-95f9-6c91f78647db",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "63eac1f5-9786-4107-99da-d493183e0db2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b1e7a260-fe9b-4ad7-9cc5-293b87e5a583",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f67544c0-2c90-4b57-90f6-7df784b5eb47",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4898dc95-7bda-47fa-af79-a083f09842b4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e9160eae-26ae-4c6e-8009-adf1b5e493b0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b1e7a260-fe9b-4ad7-9cc5-293b87e5a583",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "38c52065-c678-4ba8-927e-a2369bb883fb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "65c9df08-a4c0-4974-bb76-5eac423d2d41",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "66ca96d2-ed2f-4e3c-92ea-3f35cdec4c80",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4361afe-3adb-41f1-8a29-7305db48d916",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "76c83089-8cd8-4b19-b307-938eabfd3767",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "08f8ab25-5a9e-4d08-9f31-452d7d9ff4b0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "37ee884a-3d19-4c34-bee4-f4c23a2d25c2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4361afe-3adb-41f1-8a29-7305db48d916",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ae9c65ea-691e-427f-a363-fbe94026129b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c9141a34-f178-4dfd-8066-075b94cc8c0a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d7a6a8a1-262e-4e36-83d0-3eb3c8a71414",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4d7ccd8-899d-4f95-b217-ca1d7322106f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "cf64f645-67bf-4df5-a7ba-321c9680f638",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "545ab949-0f1e-48b4-b68f-c85beea94121",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade0"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7f147feb-1d9c-4f5e-bf7d-bb495815fb4b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade0"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4d7ccd8-899d-4f95-b217-ca1d7322106f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade0"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6e86b8c3-4941-42ce-8c63-8943e4656e0d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade0"
    }
  ]
];

const grade1CalibrationManifest = [
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c895ecdb-a7ce-49c9-a8c9-ba33eaf6078c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2da3a6d5-3008-4f7d-97fc-8cde48e66475",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "416e340b-a395-4223-9f4f-4e71cfc614ae",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "28f53ea6-a5dd-4193-a080-0312ae609c36",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5c1d714f-dbd8-45de-9382-ed4533f690d1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b951b740-9698-45f2-9908-77c2343a4abc",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e1ff7caf-df06-481b-990f-c251caeb68a2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6675a8b9-af55-406e-adee-5800480f9e8b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "28f53ea6-a5dd-4193-a080-0312ae609c36",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ba118b58-c87d-4e2f-82c9-93de52508108",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6d12f684-6a85-4ead-837c-86e282220233",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "db1fb9e2-5327-4d51-b6e9-aab90fcb53ef",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "41a40cd9-0364-49d9-abe5-0abaa386223d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4ad2b13a-e74f-4063-9598-b7fe556a4b15",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ee06dc24-255b-4f36-b958-a1d32009d4fd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b99c70b4-cc9c-432c-bb12-c1af14881240",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e46e1ef6-f639-452c-b0ab-0ab2162b2f3f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1ec97f25-601e-401e-a70c-c1a3911a2bb2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4ad2b13a-e74f-4063-9598-b7fe556a4b15",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "327f684c-7e02-44b2-82b0-724477a7e157",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "01620c0f-5f09-42e2-87da-3d76c50712c9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f1c57648-1aa0-4a25-9a4f-3360801741d6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7b513341-b08a-433b-a196-696445ceb550",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6a50bc56-8f67-4591-a72d-285207d9c75f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "70fd0e7a-3f47-4acd-bb3d-2f33c38f25d7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e4a3a1ae-44d3-4e09-888a-43f7b35cd374",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "de335fc9-5053-4767-bc41-a2f6b5e4fbbf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fb2e0e3f-6561-4173-8dde-c1282d98e671",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6a50bc56-8f67-4591-a72d-285207d9c75f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6fc82e4f-28a6-4096-9188-0fbaae8a16d5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2099b0ce-8778-49eb-9b27-b17874e72800",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "58d34c79-dcfe-400d-a8d0-287c41710ed2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b62af948-cb72-4903-8420-34c44d3111eb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "77f63f1d-9e0e-4f3b-ade3-8960dc3197c1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "48cbba4f-0a47-4c92-a985-4645a4e1caab",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6b2c8e59-d062-441e-b6df-f60894918c3c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "66adbddd-b901-4b1f-8068-d7d6717899a9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "826f41ce-0ebf-4504-b921-2e9505ac3741",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "77f63f1d-9e0e-4f3b-ade3-8960dc3197c1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5b01d166-75df-4b9a-a6d6-bbf0940affd2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b1050f6f-de06-4d64-84a6-545e0362190a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "84ead6a6-4b0d-4c72-8d66-af2ffff57485",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ba0719f7-9ea6-4c5d-99ad-5b4f68ef87c4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7fed6360-3c25-46f6-914e-a38399554a9c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e8bc3b16-a6ec-422a-9e8e-f656daf0eae8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "86735656-976b-4d56-aa3a-b470c458a1cf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d9626c9d-3502-4def-a838-612f495b5fad",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3b1dbe63-4090-4fcb-9589-deb976a5e7c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7fed6360-3c25-46f6-914e-a38399554a9c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "075a54a9-026a-4f7f-918d-f4b19faad415",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2254d5fb-62d0-46b5-8e0d-21610a9136b3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "49009070-b864-4d89-84a7-8d46fa4ed428",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "78951c4b-1236-4cb6-a750-187da74fdbf0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "83bd3cef-eb3a-4d22-ad10-c2a09419c591",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "41f9ac03-575d-4715-993a-34e1b6525b64",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b3e4d78b-1aa5-4514-94a7-9e510214948b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b42dc77e-9e2c-413e-b750-d7061636128f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "db3753b5-590a-4181-b338-e7be35fdc3b8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "83bd3cef-eb3a-4d22-ad10-c2a09419c591",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2832d8b9-15e6-4d3a-a1bf-69a290772f5f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "89f15421-19db-45e8-8cfc-ed037bdcb9f7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "90410956-113f-4ed3-99c2-e38e783dd695",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "12b158dd-3312-4b62-b276-c63160a1c301",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "88657be1-79d4-4858-a76c-db7aa51ccfc8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ff9aba6d-0a46-4b0f-879e-a7f6f73b0836",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0fd9fc59-ec98-4dce-85ec-619580b0afef",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3373bc1f-57de-4298-af24-4bf8983b6e44",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "05b2523b-da79-4029-82dc-9ce11d02d07c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "88657be1-79d4-4858-a76c-db7aa51ccfc8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "172f7cce-4bc9-435f-be5f-18f5401e740d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a3df0d42-8f83-4a43-9864-3a73cb8c0f78",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a78241f2-c428-4a40-81ed-1b8c0545137a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4e067fce-a445-4bd8-9a8b-9754ac8f90ba",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c87242c3-f7ee-49df-a882-538bc4ce03cb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bd719e10-50fa-4f9b-8752-c80cd5d94d5e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e468ce71-3257-4992-b3d2-7ec59c493996",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade1"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "99aba1ea-5db6-4b53-9901-ee61ba58b11c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade1"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e8325041-b15b-4a5c-9a75-fdc4981367f2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade1"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c87242c3-f7ee-49df-a882-538bc4ce03cb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade1"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "38c39894-93c0-471c-af68-e7ea701fd6ca",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade1"
    }
  ]
];

const grade2CalibrationManifest = [
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9303f5c7-e589-466e-b2c8-2f6e2b7440e4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c8025be5-8fd2-4b19-bf37-4a5a97dceffb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "41e46d3b-4ec8-4145-9c7c-a22cd6db4b51",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1fdac4c1-5309-4e07-a653-bac2381468c0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "923eb468-3790-4442-a826-2eac0b79d7cd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "079b9d80-1201-4c10-8962-3ee9bae6547b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "79cc70a3-c084-4eed-ad83-dd3599902dfe",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d44ef567-d083-4ca7-93fd-fd9dc662e6b4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1fdac4c1-5309-4e07-a653-bac2381468c0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ee96ed53-3c0c-49c2-8cd6-72dca802876e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8dde9423-5e3a-405b-9f6c-f0b58a66e012",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0c89d4f5-7992-450b-91c0-4603006cd002",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b327321c-719a-44cc-a16a-bd7a64ca98d2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2828c8a1-d902-4242-a22b-cd48a09b83b4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d6b2d7bc-a8f8-4a9e-b825-9a474a1e3f45",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "94276db8-9f2f-41d4-b1a6-d7c2c9fcdecf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4829f94c-95fd-4cc5-ab16-29d97c0e5d5c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2e5844da-f79f-4e01-afba-eda224a833cc",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2828c8a1-d902-4242-a22b-cd48a09b83b4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c2ea7fad-b643-4f0b-9d9d-a4080779797e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bd87c6a7-de37-471f-ae1c-5cb9f5575ae2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ace1c1e9-5177-4be0-aaeb-5eb3896e9972",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "851961ab-8af8-4f90-806c-bee206dabbf2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2cb97447-ff22-4ae7-ba8f-ab288c02c7ff",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1122de63-a814-4aff-8efe-08e43629a30c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "16b5c175-d1c9-4289-80f8-df51b3213686",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bd683572-d7c9-4fbe-859c-595319909e95",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "992e819b-2840-4c89-bf1a-a877cb961935",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2cb97447-ff22-4ae7-ba8f-ab288c02c7ff",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "828ffc47-b78e-4bf1-a2d4-1ac83cd6f5fa",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "748c908b-0eb3-40d6-91fb-654167a81552",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fcbddaab-870f-48d7-a4ca-13479affb9df",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1303db7c-d84d-4703-8713-d4434f10a59b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "550e9a32-3de0-426d-8289-9f44e0f883bb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ec5e1794-e7c0-4c62-b3ad-0005a687df30",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "94da1c2b-0ef3-4f72-9f6a-14e057c9d8fd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e10d3cdf-735e-4ea9-be89-393bc70fe611",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "104a9a3d-0f99-4fd7-b063-4305794af35e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "550e9a32-3de0-426d-8289-9f44e0f883bb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "60ee83be-5619-44e0-9bf3-0e17658d0a0d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8d1d2ca7-8d15-46d1-8851-e03ec15e8a89",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "830bb604-fe49-44c3-b8cd-33dd46126e11",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fd83d894-dbcd-4c1e-aad0-ab2eabff2b01",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "73e226c6-e934-4bbf-98d8-03fbb3164e14",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c3203433-fa93-40b1-a15d-9af66912ab41",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "010ae53c-29f0-4425-8988-230a3410607d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "88fb3812-c100-4a67-bad8-9f5fde2e81c9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4f9a4148-6f6e-4a8b-a3e1-d26a5872799f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "73e226c6-e934-4bbf-98d8-03fbb3164e14",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b6b07b68-da86-462d-a7d7-83bf156642bf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b18a6973-ba4d-4274-aae6-e551f5765f12",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "13d8de5b-caf3-44d0-9bac-b31974bf19de",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f7038fe2-5e10-4744-a109-c76f8a19549c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "88ac1048-dbbe-4788-9cea-7e4abccc4d31",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d192c89d-012e-4f33-8c07-84505757141f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "98a630d2-888f-4d78-b80a-c784899c352c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1474f69d-e5bf-48de-8644-4dadd3cdfe0b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d23c4a1c-087a-4d9e-9b54-104194faf21b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "88ac1048-dbbe-4788-9cea-7e4abccc4d31",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e1b47e37-ff82-47a1-85c5-bb433f6ca323",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f58c51f4-afaa-4533-80bf-3d41c130842a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "da69e6cf-cb43-4a1f-9018-813e43e431e2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0f47d17d-3ea2-4b75-b2ce-a72d460d5f59",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9d83ac1d-26ff-4d82-b665-eb42aeeeb8b6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "52466a34-ba52-4047-b97c-f186ef09d2c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4f75979-8b71-4221-85de-ab9146d38e7c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8594ec1a-36c0-4058-9cf2-49e82bb06ae5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5bc28677-4c4f-4098-99d5-8270237b5868",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9d83ac1d-26ff-4d82-b665-eb42aeeeb8b6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f33b5ce3-719e-4dba-abd8-454c6e22d355",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3d1f4733-ebaf-422b-a3ad-5d220d37fbc2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3c03a298-85f8-41d4-b2e3-427d6e6a7d7c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "29255e3a-68f6-491e-a0e7-43db7cf26903",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b9e84610-67b3-4b81-9ee1-d5ab446b945d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3027da68-14f9-4a2a-a2d8-0f6a29f414c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ],
  [
    {
      "activityType": "dyslexia",
      "type": "dyslexia",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "238c7646-7983-4f38-b632-49e9892aa38a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "dyslexia for grade2"
    },
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "973eae89-7793-4cd5-9f38-5ece82987938",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade2"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "059e8c34-9a12-4d18-a3d7-f17dd6ebc178",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade2"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b9e84610-67b3-4b81-9ee1-d5ab446b945d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade2"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "aaebd733-ab2b-40da-9f19-c897ae91a809",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade2"
    }
  ]
];

const grade3CalibrationManifest = [
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "af1e859f-2fa2-477c-86e2-c5b6669ef243",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d2e96853-440f-4c67-82f9-3a5278985088",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "01e052a2-c641-41cb-bc31-73d018e7cbc9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "976d9c8d-ed7c-403b-ac4a-9e4fa374ee08",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8e68245c-a22e-416a-8157-f4134ee1266b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "01e052a2-c641-41cb-bc31-73d018e7cbc9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "35054e7d-71ad-490c-be73-87bb39ed9f58",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9c4c9272-c5d9-4928-8efb-ae696a6b92af",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2fe7eae4-c4a3-47a0-be3c-2f1aeafcfae8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7b1508a4-2c6b-444c-a27e-9fda5c87a0e3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ebe73eaf-539a-46d9-92e4-959013b64dad",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "aa660d72-c2f8-4608-af34-dc9eb8c19c4f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2fe7eae4-c4a3-47a0-be3c-2f1aeafcfae8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ddc20270-11c4-4011-b8b4-469f4e8dc418",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "19e1bc9b-dea4-474c-b917-3c23f26da7ba",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2a1b7086-1c36-4abc-8623-014ab340fcc9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3426c0b3-6b7f-4823-9ede-4a6181563699",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "202d5dc9-80ff-479c-a770-c21d6e475d79",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2c055704-3a6c-46ec-8c6c-618ac0853ac0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "daa08df7-6155-4d90-a588-c36fa2d29f6a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3426c0b3-6b7f-4823-9ede-4a6181563699",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c07eaf98-56db-4c6c-b166-1b750d2fa10d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "24bce19a-3f19-4383-b95a-2842392836b4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c71a132f-f065-471e-82b8-ccc5729e8444",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5254b403-a424-41dc-860a-8298caf3ce3c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "07e5bedd-f907-4915-ad0c-ea948ad42382",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1e3be8af-c717-4871-938f-2868854a8424",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7d19fce5-d415-4566-89d3-9468cfab2d9a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5254b403-a424-41dc-860a-8298caf3ce3c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a91dcf71-66cd-40cf-9d09-d2a24e5d6d3d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0224a4e0-56e4-46fc-bd53-cabdafde7c4b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5d641e8d-43e4-4b4a-8c5d-1ca275f1fd22",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7c709341-829f-4fc2-91e0-c8b08f187c2f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7fb5c37e-5204-4909-ba70-f0153824f341",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0f8d659b-911c-4551-8fad-cf796050b293",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bb2ee485-2399-430a-922f-46d4d7236a7e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7c709341-829f-4fc2-91e0-c8b08f187c2f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a48a2d86-3096-455a-af3c-d47e180d8619",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "cfd7c3be-319e-4f09-87fd-0ddc97793b0b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4d050e9b-5a9c-4bbc-ba64-bff275bcf6f7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "924ae29f-70c9-44ff-83ac-99bbdcadae26",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b2b5b7a7-cf80-4a27-a8ba-09a739a31172",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ecd89d71-1401-42d2-89c9-c07295bcc528",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ba6bee70-ee26-46de-9018-f12658153daf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "924ae29f-70c9-44ff-83ac-99bbdcadae26",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f582814e-742b-4f95-b1ea-3bee2284e269",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1f133ec9-6875-421a-88a6-a28191e5cd7b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "980063aa-44c5-4fd3-8125-19eb547144a2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "cf41a97c-4125-4688-8900-cab4fe879547",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "94fed41e-18b1-421a-a1b1-935fff00a2b7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0fdbf057-4f7e-4f15-832c-6704776c8fb7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5ece888a-c1a1-4934-8fa2-546d280c8c85",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "cf41a97c-4125-4688-8900-cab4fe879547",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b2a16795-f9f3-418d-82ab-ef638282f4eb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5526c551-967c-4da0-9030-b8538ea0546e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "13f54108-55a4-43d2-a093-b9f62e415b0a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dad56dc1-1a31-41de-b9c1-6eccba57f936",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4705fa0f-28a0-40a9-a49d-9fa6733a2617",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8bfd7988-5dbc-45ab-a401-d92fb3e95ca9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f15de01e-252a-40b9-b029-0f7fcd60d578",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dad56dc1-1a31-41de-b9c1-6eccba57f936",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bde04c27-4c4a-4027-bd79-d7263f0cc2c8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5526c551-967c-4da0-9030-b8538ea0546e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "13f54108-55a4-43d2-a093-b9f62e415b0a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dd59d0ff-35b6-4dbd-bbd9-53536293e6bc",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1176398e-b927-4ad4-bb7f-20b8b009d3c7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ],
  [
    {
      "activityType": "nwf",
      "type": "nwf",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8bfd7988-5dbc-45ab-a401-d92fb3e95ca9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "nwf for grade3"
    },
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f15de01e-252a-40b9-b029-0f7fcd60d578",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade3"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dd59d0ff-35b6-4dbd-bbd9-53536293e6bc",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade3"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bfee35ae-2001-4af3-aa7f-625763e18433",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade3"
    }
  ]
];

const grade4CalibrationManifest = [
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3a972000-231c-429a-a3de-3a11f9d4d7b8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4218c5ed-acd7-45ba-abce-2cd261e9588d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f6a25c00-8f6b-4469-a53b-928726ed370f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d197ca21-2915-465c-a40a-d05c7e8283b2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4218c5ed-acd7-45ba-abce-2cd261e9588d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "56f8ae4c-7a9c-409b-80f6-eb69d6c53e65",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "68c1f0a1-de40-4ce6-8a01-340cebb53f6e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "620088c4-7409-4916-aa9b-7da92b1f49b5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "691d29ca-0e69-4c4f-9473-c646e5772590",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "53c1d3d8-27de-4ff2-b67e-e49f5910bb33",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "620088c4-7409-4916-aa9b-7da92b1f49b5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0929b2a2-2c50-4aa5-b38c-f4ef22fc48e5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ba3311a2-4b49-448b-a562-624b39dd2466",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "894634c5-6f71-4291-a7d7-a622f4ddc164",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "72b38464-9762-45a7-8a54-67ba849dea58",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1944d4f1-cd0f-4d5c-88c8-5112dad68485",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "894634c5-6f71-4291-a7d7-a622f4ddc164",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c3709bfe-6fd3-4f0c-bcca-bef62dbb15d9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "11ba330d-3906-4bd9-8301-54f30bcd1bac",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a91696a7-08c2-4953-bb2d-013ab4e88c51",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2b2e1328-9059-446c-a7e0-6ba671514e96",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9fce84dd-91fa-425e-8fca-242a14c76068",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a91696a7-08c2-4953-bb2d-013ab4e88c51",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fd04a36f-4392-46f1-a55d-70f43f0ad9bf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "591dc9fd-458e-40db-b009-3e1f6f2ab831",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "addeec62-bab2-4002-8bc4-fd9ebad5ac16",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a90f7706-1a10-41e0-8c5a-fcdc14af7c19",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "06a7f92f-7fbb-42ce-9c8b-36731f37650b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "addeec62-bab2-4002-8bc4-fd9ebad5ac16",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9b74b867-0486-459a-aabb-54789d27bd1b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7b46c9d0-6680-4888-8b17-5196b4d3885f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b37f2a6b-93ac-4a82-ac86-920858edba6b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "70866a1d-786a-4d99-bb64-0336f069be3e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3eba3b22-42e4-4854-82ce-881d59b374e9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b37f2a6b-93ac-4a82-ac86-920858edba6b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "46eef29f-0a79-4033-af45-0df482f457b1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "aa555d53-c9c2-41e3-9b3c-b776d035c6cb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bac3221b-29dd-4a90-a235-b6620233b914",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a90518b6-72a9-46fb-a6f2-0d3f977518c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c9e4bd5c-d434-41c8-90da-1ac69fb14653",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bac3221b-29dd-4a90-a235-b6620233b914",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9bac059b-f96d-4b76-ac10-cc3f18ffe4ec",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "05ed6a39-6025-43e3-8a08-258e7058fded",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c6f57f23-00dd-4c7b-86ea-bc32ed5e0678",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "141ff056-a3f9-4f07-a258-29943b483a4b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "74d9bd54-841e-483f-b756-0bdd42b7b8fb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade4"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c6f57f23-00dd-4c7b-86ea-bc32ed5e0678",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade4"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a01c4c58-e53d-482d-971c-dedaa60c1d08",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade4"
    }
  ]
];

const grade5CalibrationManifest = [
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a62a905d-3928-4bf7-8e68-a3267d7c668a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "39df145b-e8ca-4dd4-8772-2a1137ea8001",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8908b20e-138c-4778-959b-136c9eeba80f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0c768681-7680-43b8-b965-f3668d7bc1a7",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "39df145b-e8ca-4dd4-8772-2a1137ea8001",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ffa3a491-9ef5-498b-8a29-f66a3e81d8d1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ac959b7f-bf78-46b2-805b-dc678c5c9287",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3db3feff-f664-45ab-b051-cfdc07f24c6a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4aae633d-801c-4759-b792-599d7cc9b626",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8d6cc68b-23d3-472d-956d-6b0ec0278389",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3db3feff-f664-45ab-b051-cfdc07f24c6a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7d893640-192e-43ef-b9ff-7fc3c4b97821",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ef1f40d1-b85b-4a86-9dd2-47e076ce141c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "76e7f540-6768-4079-9553-2417fde9baac",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f8719089-72df-4fb3-a932-64470298586f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "afb8233a-64b8-4a39-81d5-a3a5f7ca66f5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "76e7f540-6768-4079-9553-2417fde9baac",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6741ebb9-c507-4661-b469-d6655ceef80f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "295fa441-c8c3-481c-a83a-6251d1100eee",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9f54bb3f-a6f7-467d-876e-b9487fae6288",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "229836fa-551a-4069-9d43-8aabf701be41",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a56b8fb6-970f-4fdd-bff8-04056e0e13cf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9f54bb3f-a6f7-467d-876e-b9487fae6288",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "66487825-2e56-4e72-84bf-a131f9e3dff4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4a51e6c9-0383-4f36-a7d2-964eda9ca911",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ab062ba3-be43-4f2b-a00e-951ca0bf2f7e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "de0d9576-0a1d-4d7f-b7c1-1dba22dfb257",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2122b955-245d-4fbc-bcc3-81da7b8757c2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ab062ba3-be43-4f2b-a00e-951ca0bf2f7e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d4fbcc1a-b485-467a-a282-cd63606fb9e1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c1257cd5-7f5b-429d-b4b1-c9dca046153c",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b8eb7edf-b0cd-40fd-809a-da4ce12a9562",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c4035155-09a4-4adb-93e1-b038cf74b04b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5d4f0d4e-5326-4d61-a470-e3a7feba344b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b8eb7edf-b0cd-40fd-809a-da4ce12a9562",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e5fb62bc-f431-4bf0-830d-2aa669a4d3dd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a4685e74-0699-48ec-ba30-dec935656f47",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dcf4ee4f-6c14-4a53-82d1-f709f941f006",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dd42a729-b934-4e54-9ac7-9f11da53283f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c5ae0058-2477-4fc0-beb4-fd4ebf163757",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "dcf4ee4f-6c14-4a53-82d1-f709f941f006",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "795f0796-381a-42a9-a54a-5f17224d2ef4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "496d4e20-4f87-4eec-a5ba-abfed1573ed6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fc17d821-c0fe-41d9-9456-5d76fd2e57c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "89e75d73-43d5-4595-9f00-04a603d06802",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5b903b66-3426-4104-9588-a6a1c7a5fed3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade5"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fc17d821-c0fe-41d9-9456-5d76fd2e57c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade5"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0af589a1-a810-462e-ba2f-4ee5c56622ed",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade5"
    }
  ]
];

const grade6CalibrationManifest = [
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3091fe45-f0d0-415a-8a4e-ff69aabe2058",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "06d266e0-ea6f-47b4-bb25-1ecf825c8181",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "24ce070f-3949-4ebd-8a28-95dda0bd0b11",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5e3e1098-6fe3-4a06-a398-577e97a69ebb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "06d266e0-ea6f-47b4-bb25-1ecf825c8181",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c3b0957d-8cfa-462d-ac53-36b453e4c940",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f08645dc-6779-4547-b2da-ff09359cb329",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4525445e-d371-4e33-a9b1-7ef6a7bbfc20",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fd50ab5e-f1cd-40db-837d-df0f28e70799",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "26910afa-f89f-471d-9468-c06d83e7d0c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4525445e-d371-4e33-a9b1-7ef6a7bbfc20",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "19434718-2c3f-4f65-8a54-fc687e346176",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e31f46ff-9e6b-4079-9454-1bfe5ea572f2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4805c53d-a7be-4435-8737-bb812da243ff",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b1800619-4626-4816-abbe-4e3f2f4b878e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2992dd95-c8a4-4106-b659-8f21198c2a2f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4805c53d-a7be-4435-8737-bb812da243ff",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8b45d995-ca14-42f1-a6c0-d89cbe1c7702",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "636d0174-97af-45db-a081-e46040de7d16",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4d617fae-8de6-4beb-b3c4-eaf5df967f56",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "3e7fd321-91a7-434c-b3ce-71dcb4d193d5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "02823623-c60d-4223-8066-3adf1323b4cf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4d617fae-8de6-4beb-b3c4-eaf5df967f56",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a3cf8660-ccf8-4742-a1dc-2a5f63953467",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "76b0d1d4-bab8-471b-9f75-7a3388d0b510",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "719084a8-5e8f-44ea-a323-1bfb3ddc7d1e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "66493011-e232-42b0-a991-d9648d791843",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f0734bc6-f007-4f26-814a-e5405f81ef47",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "719084a8-5e8f-44ea-a323-1bfb3ddc7d1e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1a252bed-cad9-42c9-96c1-fb409812a566",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5d4cdc74-7250-40c7-b04b-2f773b4b4e38",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7e670321-bd9a-4c77-9fe3-75d5593f7c48",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6fb130d4-b2af-40fb-b097-8f683c0a9530",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "35a235a5-9529-4f4c-9719-e9ac5754ab16",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7e670321-bd9a-4c77-9fe3-75d5593f7c48",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "a95f2700-ccfb-4162-afe3-a8ecf14ecc9a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8c2c4831-5b87-46b1-bc6e-ae371a06076d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f5f88e78-b372-4aa1-bc97-e49764dc18fe",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6b2d9509-1cca-4fde-8361-f0f12b1b1f4d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d41b6db9-5748-4603-bc38-4ca5d6fb8cff",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f5f88e78-b372-4aa1-bc97-e49764dc18fe",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "aaf0c181-9c16-466c-bccc-564268c20e54",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9470241d-0712-4248-8749-72ba36181a31",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f8a948c7-e36b-4a21-a86b-c6e4c2007e57",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4363866b-2e06-4c46-9e99-ddfe848334d3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9a8d9b87-a6a5-436f-b554-b7ae4a207a4d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade6"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f8a948c7-e36b-4a21-a86b-c6e4c2007e57",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade6"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "edf23dc0-cfc9-4b8d-a6ba-5f503b4088c9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade6"
    }
  ]
];

const grade7CalibrationManifest = [
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ed048508-04c4-4e0c-9eac-850c6e3256da",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0f3edb3e-23a7-437b-9a3d-87332bbb2651",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6cca9142-5309-4f48-9453-e51e1a8c040a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c31ca9ce-609e-47c0-957c-c5f75a00abfd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "0f3edb3e-23a7-437b-9a3d-87332bbb2651",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f2a320b3-b9dc-44ff-828b-0b29bcbbf11f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9a18c6fd-6337-42e0-9397-a9950a6c67c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "20a493ad-1f2d-434d-ae8f-e46c40df7298",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "aedab4bd-5e46-41b3-923b-f90ece156def",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ada17525-acd1-4171-82f5-6c2933dac6b9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "20a493ad-1f2d-434d-ae8f-e46c40df7298",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6201ca95-9756-48ba-b3b2-c0fff0a58fe2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "62b0808d-ef59-4609-aa7f-879a4f59e766",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2e948826-b0f4-4583-b839-f0cf8069ec66",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "297e904e-eb1d-4c50-a56d-25f400fa491e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "af3e69d3-9bd0-4a9d-82d8-1f735de84207",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2e948826-b0f4-4583-b839-f0cf8069ec66",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "31b99146-9918-409b-a276-bd04de2b33ba",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ee06143f-9961-4475-82d8-065073ab25a2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "331b512c-c1c7-46f0-8e05-940190b24dc6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7adcc08a-0ef0-488c-a60f-e3710206ba23",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9d826313-d848-4999-8947-838f261471bb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "331b512c-c1c7-46f0-8e05-940190b24dc6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1d42c0cb-0d3b-4c43-afc9-a01aee401a70",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c9603ac2-fd58-405b-a750-8c6618bf7b8e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "400fff7d-ae23-4d32-8ffe-023ca2fa6f75",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e23c345d-938d-497a-bcdf-915df56ea884",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fe3bf77d-6510-4938-a4b7-fb400617cad5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "400fff7d-ae23-4d32-8ffe-023ca2fa6f75",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7cfeb381-e5d4-45c5-8e7c-8d24b02455e4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "db735c35-ebd3-4c46-8ca7-3928528fa56d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "53dcecaf-0101-41bd-be0b-fa220eb8df71",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c64fb489-c895-483f-a50f-5d823bf24f75",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7450fc1e-5965-4b3c-9a79-95e878f24ff1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "53dcecaf-0101-41bd-be0b-fa220eb8df71",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "94f2695a-94d0-4ff2-a25e-69bbe30b771d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "964ed4ef-2cde-43f0-aacb-54b6f8a76480",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "62742534-61ad-4d23-a85e-fe2efaf94d80",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "23eda295-71fd-492c-953c-950eec606cb9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d200f8a7-08b3-45a9-9eae-a7534758992a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "62742534-61ad-4d23-a85e-fe2efaf94d80",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f103fe85-5796-4fb2-bd5b-80c35677bb0d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "83d122ac-3f30-4d68-8732-4dbf8779d05d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "843b37f9-5a37-4a36-b11a-4d59179cafaf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8595204d-cb19-4ab8-814b-a911767e5b25",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7d97c0ba-26cf-4623-8470-da78d3a07a5d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "843b37f9-5a37-4a36-b11a-4d59179cafaf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e4f78962-f7e9-4e71-936c-d427a2468121",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "db735c35-ebd3-4c46-8ca7-3928528fa56d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ae0a2da0-dbe0-46e0-af42-42d998e887c8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f223fa0b-e7d5-4c09-900c-29b5d5addb21",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7450fc1e-5965-4b3c-9a79-95e878f24ff1",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ae0a2da0-dbe0-46e0-af42-42d998e887c8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ad81db8f-d714-433c-8d43-759dda6126c5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "964ed4ef-2cde-43f0-aacb-54b6f8a76480",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c130978a-e852-4d25-ac51-5a74dff15d63",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e00e0545-414f-48e3-844b-0cc3a3ebc219",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d200f8a7-08b3-45a9-9eae-a7534758992a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c130978a-e852-4d25-ac51-5a74dff15d63",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c136cb59-e66d-44bd-82ad-bea3501795e0",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "83d122ac-3f30-4d68-8732-4dbf8779d05d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c6929405-b87b-4860-bded-67a3ea737dd6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "42489292-fb56-467a-8684-1f1eb08addd2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7d97c0ba-26cf-4623-8470-da78d3a07a5d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade7"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c6929405-b87b-4860-bded-67a3ea737dd6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade7"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fad8b27b-5d03-4cf9-8bee-8bd1a5911c07",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade7"
    }
  ]
];

const grade8CalibrationManifest = [
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "38b46dd5-11e6-4cc7-a53f-b5aab9c24250",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "57412d10-509d-40f8-95ec-bb75939ebfc5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "b9333949-f812-4cba-b406-bd9fb88f2f7f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e7e85c86-f198-4364-83b7-f331c4d995e9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "57412d10-509d-40f8-95ec-bb75939ebfc5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "161a4098-f6ce-42f4-900a-c33260529828",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e2d745ee-3635-4e15-bc78-9587f02dda65",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5b7dc069-b76f-4e2f-a8ca-38a4b81090d4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "2afbc7a9-aa0f-4536-a9ea-c4d7e3112a40",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "eb34158b-6c77-409a-922e-70e885e92bce",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5b7dc069-b76f-4e2f-a8ca-38a4b81090d4",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "69a43257-5cc5-4563-8d9e-f5a8ada40d32",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "65c945ce-cdfa-4216-b432-b4e538e926c8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6bfe60cb-a2f1-4ab9-9aaa-b1e5a0a6a7e8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5f6f5f23-154b-4623-8a45-3898fe6d1826",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "120dfa38-2f1a-49e6-a87e-550b7e041412",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6bfe60cb-a2f1-4ab9-9aaa-b1e5a0a6a7e8",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8f6c3abd-f335-4a72-a8ea-39d2a6da8d86",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "96f61c05-bd5c-4d7a-8b96-a0b2b6b857e6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "904ce8e9-ba00-4af8-8758-13d1048097e9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "74624b4f-fde8-4954-94f2-169c5e92149b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5949cc1f-ba44-4650-b553-7196304b8497",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "904ce8e9-ba00-4af8-8758-13d1048097e9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "c283aaa4-e553-4da6-bb32-1c6448970e7b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6bf8fd1b-851f-4cd9-bbd6-c7fc772cd3ba",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9ceb599a-47a6-4742-bd89-74be0a4e1e40",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "5d0d0393-5ac8-4f3e-be3a-4e9b9fe889be",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "ab4070cd-f968-45e3-9e08-da0fe9221e65",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9ceb599a-47a6-4742-bd89-74be0a4e1e40",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "7e8bf0bc-2c03-46fe-bb69-459287f4e4eb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "31e89757-8416-44fa-8b95-07af08b95c8d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bcef845f-faf8-430c-b6ac-f68247960c6e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "1e9d4f60-90d1-459d-8f01-d6b67be5da5a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "428a073a-9935-42e6-88bc-c3a3b12d2ea9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "bcef845f-faf8-430c-b6ac-f68247960c6e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8675deac-1753-4905-940d-f0665d7e117b",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "55585a09-8012-4d1a-bec8-7696685c327f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d157df51-b8d7-4131-adce-86db0927e0c2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "fe3630cd-a379-4b62-ac32-db3dbac50d7a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e79c27fe-90f1-46d3-a723-b3d78f35d19e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d157df51-b8d7-4131-adce-86db0927e0c2",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "de1732e7-a7f6-4706-b04a-3101986318cb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4783a9a4-4c2f-4882-b701-9770b85df82d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d4fe2f99-b264-4c28-8bbf-bde12c31ce0d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "8e9f69b4-0822-4f01-ba83-d4339bdb1e54",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6b51eb15-5c89-4d41-8b60-cb00d0572003",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d4fe2f99-b264-4c28-8bbf-bde12c31ce0d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "934453bd-6151-4013-abf8-47fe1c7fb8cd",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "31e89757-8416-44fa-8b95-07af08b95c8d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "de509384-c013-4735-b75e-1eb13eac72c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f3d88062-6c12-4039-af6b-bf55af3356e6",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "428a073a-9935-42e6-88bc-c3a3b12d2ea9",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "de509384-c013-4735-b75e-1eb13eac72c3",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d8c1ca65-49ca-4767-8f87-98a95b590c9f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "55585a09-8012-4d1a-bec8-7696685c327f",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f17dfe0c-47b1-4611-a40f-a7520114f755",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "76220fc1-e7f8-473e-a1e5-815dc0a07c1a",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "e79c27fe-90f1-46d3-a723-b3d78f35d19e",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f17dfe0c-47b1-4611-a40f-a7520114f755",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "89ee30d9-f0f3-4880-9829-e68f9044f8cf",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "4783a9a4-4c2f-4882-b701-9770b85df82d",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4033b1f-ccab-4971-90f5-3a286e1a71fb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "9f138020-da9a-41e9-ad33-8d93cb3f44db",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ],
  [
    {
      "activityType": "spelling",
      "type": "spelling",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "6b51eb15-5c89-4d41-8b60-cb00d0572003",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "spelling for grade8"
    },
    {
      "activityType": "assessment",
      "type": "assessment",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "f4033b1f-ccab-4971-90f5-3a286e1a71fb",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "assessment for grade8"
    },
    {
      "activityType": "readingComprehension",
      "type": "readingComprehension",
      "locale": "en-us",
      "sequence": "CONTINUE",
      "status": "ASSIGNED",
      "storyId": "d3565c2b-fb3a-4e9e-bff0-8a21ba5a6ce5",
      "activity": [],
      "tags": [
        "NO_QA",
        "NO_EDM",
        "NO_SCALING"
      ],
      "isCalibration": true,
      "title": "readingComprehension for grade8"
    }
  ]
];

function selectCalibrationManifest(grade) {
  switch (grade) {
    case -1: return grade0CalibrationManifest;
    case 0: return grade0CalibrationManifest;
    case 1: return grade1CalibrationManifest;
    case 2: return grade2CalibrationManifest;
    case 3: return grade3CalibrationManifest;
    case 4: return grade4CalibrationManifest;
    case 5: return grade5CalibrationManifest;
    case 6: return grade6CalibrationManifest;
    case 7: return grade7CalibrationManifest;
    case 8: return grade8CalibrationManifest;
    default: return grade8CalibrationManifest;
  }
}

export async function getCalibrationAssignment(grade,assignment,forceCalibration){
  //Don't transform the assignment if it's outside the range of grades we have
  const possibleManifests = selectCalibrationManifest(grade);
  let calibrationManifest = null;
  if (!forceCalibration && (!assignment || !possibleManifests)) return assignment;
  if(forceCalibration){
    const {grade,index} = splitAndConvert(forceCalibration);
    if(grade !== null && index !== null){
      calibrationManifest = selectCalibrationManifest(grade)[index]
    }else{
      throw new Error("Invalid forceCalibration value");
    }
  }else{
    calibrationManifest = possibleManifests[Math.floor(Math.random() * possibleManifests.length)];
  }

  if(!assignment || assignment.assignmentType !== "CALIBRATION"){
    assignment = createDummyAssignment(calibrationManifest);
  }

  //Create the manifest for the calibration assignment
  let newAssignment = JSON.parse(JSON.stringify(assignment))
  newAssignment.manifest = calibrationManifest;

  newAssignment.manifest.forEach((activity)=>{
    const assignmentActivity = assignment.manifest.find((a)=>a.type === activity.type);
    activity.status = assignmentActivity ? assignmentActivity.status : "ASSIGNED";
  });

  //Skip any activities that are not in the calibration manifest - this is important for the tracking report
  let skippedActivities = [];
  if(!forceCalibration){
    assignment.manifest.forEach((activity)=>{
      if(!calibrationManifest.find((a)=>a.type === activity.type)){
        skippedActivities.push(activity);
        activity.status = "DONE";
      }
    });

    if(skippedActivities.length && !forceCalibration){
      await Promise.all(skippedActivities.map(async(task)=>{
        await skipActivityInManifest(assignment.assignmentId,task.activityType,"EN_US")
      }))
    }
  }

  return newAssignment;
}

export function getScreenerOverrides(assignment) {
  if (!assignment) return {};

  // Walk the calibration manifest and return the screener overrides
  let overrides = {};
  assignment.manifest.forEach((activity) => {
    overrides[activity.type] = activity.storyId;
  });
  return overrides;
}

function splitAndConvert(input) {
  if (!input || typeof input !== "string") {
    throw new Error("Input must be a non-empty string");
  }

  const firstChar = input[0]; // First character
  const remainingString = input.slice(1); // Remaining part of the string

  const firstNum = parseInt(firstChar, 10); // Convert first character to a number
  const remainingNum = parseInt(remainingString, 10); // Convert the remaining string to a number

  return {
    grade: isNaN(firstNum) ? null : firstNum,
    index: isNaN(remainingNum) ? null : remainingNum
  };
}

const dummyAssignment = {
  "assignmentId": "11111111-2222-3333-4444-555555555555",
  "assignmentType": "CALIBRATION",
  "createdAt": "2024-12-17 00:33:49",
  "dateFrom": null,
  "dateTo": null,
  "entityType": "STUDENT",
  "parentId": null,
  "status": "ASSIGNED"
};

function createDummyAssignment(manifest) {
  let newAssignment = JSON.parse(JSON.stringify(dummyAssignment));
  newAssignment.manifest = manifest;
  return newAssignment;
}
